module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_5_1-f8ebe4f0c11ab749acfbc36c9fc65e6a.png";